import { useContext } from 'react';
import RefillingContext from '../contexts/RefillingContext';

const useRefilling = () => useContext(RefillingContext);

export default useRefilling;
